import { ReactNode } from 'react'

import { Link } from '@elements/link'
import { useRouter } from 'next/router'
import classNames from 'classnames'

export interface NavigationBreadcrumb {
  href: string
  label: ReactNode
}

export function VenuePageNavigation({
  breadcrumbs,
  className,
}: {
  breadcrumbs: NavigationBreadcrumb[]
  className?: string
}) {
  const router = useRouter()

  if (!router) return null
  return (
    <nav className={classNames('p-3 sm:px-8', className)}>
      <ol className='flex items-center justify-start space-x-2'>
        {breadcrumbs.map((breadcrumb, index) => (
          <li
            key={breadcrumb.href}
            className='flex items-center justify-center space-x-2'
          >
            <>
              {index !== 0 ? <span>&gt;</span> : null}
              {index === breadcrumbs.length - 1 || !breadcrumb.href ? (
                <span>{breadcrumb.label}</span>
              ) : (
                <>
                  <Link href={breadcrumb.href}>
                    <span>{breadcrumb.label}</span>
                  </Link>
                </>
              )}
            </>
          </li>
        ))}
      </ol>
    </nav>
  )
}
